import { Link } from "react-router-dom";

// A responsive grid of post cards. Used by the Blog, Home, and topic pages.
export const PostGrid = ({ posts }) => (
  <div className="post-grid">
    {posts.map((post) => (
      <Link key={post.id} to={`/blog/${post.id}`} className="post-card">
        <time className="post-date">{post.date}</time>
        <h3>{post.title}</h3>
        {post.subtitle && <p>{post.subtitle}</p>}
        <div className="tag-row">
          {post.tags.map((tag) => (
            <span key={tag} className="tag">{tag}</span>
          ))}
        </div>
      </Link>
    ))}
  </div>
);
